export default "__VITE_ASSET__105caee8__"